// Operation job detail route (/ops/jobs/$jobId) with live progress; the screen is JobDetailPage.
import { createFileRoute } from "@tanstack/react-router";

import { JobDetailPage } from "@/features/jobs/JobDetailPage";

export const Route = createFileRoute("/_app/ops/jobs/$jobId")({
  staticData: { crumb: "Job" },
  component: JobDetailPage,
});
